import { render, staticRenderFns } from "./saleorders.report.vue?vue&type=template&id=596fcc74&scoped=true"
import script from "./saleorders.report.vue?vue&type=script&lang=js"
export * from "./saleorders.report.vue?vue&type=script&lang=js"
import style0 from "./saleorders.report.vue?vue&type=style&index=0&id=596fcc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596fcc74",
  null
  
)

export default component.exports